// Derived from the generated GraphQL operations (codegen output), then hand-trimmed.
// There is no codegen config in this app — maintain this file manually and keep it
// in sync with applications/account/backend/appsync/schema.graphql.
// Trimmed for the Account app: only the operations it uses are kept.

export const getUserDetails = /* GraphQL */ `
  query GetUserDetails {
    getUserDetails {
      organizationId
      organizationName
      userName
      displayName
      email
      __typename
    }
  }
`;
